import { IResponse } from "models";

export enum ActionType {
  CHANGE_STRESS = "action/CHANGE_STRESS",
  CHANGE_STRESS_SUCCESS = "action/CHANGE_STRESS_SUCCESS",
  CHANGE_STRESS_ERROR = "action/CHANGE_STRESS_ERROR",
  CHANGE_STRESS_RESET = "action/CHANGE_STRESS_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IChangeStressPayload {
  start_year: string;
  start_month: string;
  end_year: string;
  end_month: string;
}

export interface IChangeStressResponse extends IResponse {
  result: any;
}
